import {createContext} from 'react'

export const MenuGroupsContext = createContext({});
